import { LocationUtilities } from './utils';

var emailOnlySignup = function (Freshworks, $ = jQuery) {
  LocationUtilities.onLocationReady(function (geoLocation) {
    const openFormInOverlay = function (continent) {
      if (window.emailOnlyFormModalOpen) {
        return;
      }
      let $form = $(this).parents('.email-only-signup');

      // Move the form to the modal holder and position it
      // at the same offsets as the source form
      var originalPosition = $form.offset();

      // Create a placeholder of the same dimensions
      // as the form and add it before the form
      var fromFillerDiv = $('<div>')
        .addClass('email-only-signup-filler')
        .css({
          width: $form.width(),
          height: $form.height()
        });

      // Hide the modal if email only signup is already opened in a modal
      // Eg: Freshwork home page email only signup is already opened in a modal
      if ($(this).parents('.modal').length) {
        $(this).parents('.modal').modal('hide');
      }

      $form.before(fromFillerDiv);

      $('#form-modal-holder').css(originalPosition).append($form);

      // Activate email field, lock body scroll and fade the overlay in.
      $form.find('.email-field').addClass('active');
      $('body').addClass('no-scroll');
      $('#modal-backdrop').fadeIn(100);

      // In case of GDPR controls being active, fade in the GDPR
      // terms and wordings, in other cases, add a back button
      // to dismiss the overlay
      if (continent === 'EU') {
        $form.find('.eu-extra-info.modal-on-click').fadeIn(100);
      } else {
        let modalDismisser = $('<div>')
          .addClass('button--ghost backward--link  modal-back-button nav-sticky-overlay-dismiss')
          .css({
            position: 'absolute',
            'z-index': 1001,
            top: 65,
            left: 0
          })
          .html('back')
          .one('click', hideModal);
        $('#form-modal-holder').prepend(modalDismisser);
      }

      // Focus on the form and update the state.
      window.setTimeout(x => $form.find('input[type=email]:eq(0)').focus(), 200);
      window.emailOnlyFormModalOpen = true;

      if (continent === 'EU') {
        // Since the GDPR elements are absolutely positioned,
        // scroll the form fully into the view
        if ($(window).width() < 960) {
          $('html, body').animate({
            scrollTop: originalPosition.top - 20
          }, 500);
        } else {
          var endOfView = $(window).height() + $('html, body').scrollTop();
          var endOfForm = originalPosition.top + $form.height() + $form.find('.eu-extra-info.modal-on-click').height();
          // If size till end of vision is LESS-THAN position of form + size of form (input + eu-extra-info since the latter is absolute positioned), then scroll to view that ends with form + 50px
          if (endOfForm + 50 > endOfView) {
            $('html, body').animate({
              scrollTop: endOfForm + 50 - $(window).height()
            }, 500);
          }
        }
      }
    };

    const hideModal = function (continent) {
      if (!window.emailOnlyFormModalOpen) {
        return;
      }

      // Reset and remove active status from email-only sign-up field.
      var $form = $('#form-modal-holder').find(' > .email-only-signup');
      $form.find('input[type=email]').val('');
      $form.find('.email-field').removeClass('active');

      // Remove the back button, in the case of nav-sticky
      // modals, BEFORE moving the form back to it's original
      // location since the back button is a sibling element
      // to the form and we use this in our DOM search.
      $form.siblings('.nav-sticky-overlay-dismiss').remove();

      // Remove the placeholder element and unlock scroll on body
      $('.email-only-signup-filler').before($form).remove();
      $('body').removeClass('no-scroll');

      // Hide the Modal backdrop, GDPR wordings, and update state
      $('#modal-backdrop').hide();
      $form.find('.eu-extra-info.modal-on-click').hide();
      window.emailOnlyFormModalOpen = false;
    };

    if (geoLocation.continent.code === 'EU') {
      // Handle overlays when GDPR restrictions need to be in effect
      $('.eu-extra-info.modal-on-click')
        .parents('.email-only-signup')
        .find('input')
        .on('click focus', function () {
          openFormInOverlay.call(this, 'EU');
        });
    } else {
      // Hard-code unsubscribe to false to ensure that
      // users can optionally unsubscribe to updates
      $('.eu-extra-info.modal-on-click')
        .parents('.email-only-signup')
        .find('input')
        .on('click focus', function () {
          let $form = $(this).parents('.email-only-signup');

          // For single-field sign-up forms on the nav, when the
          // nav is made sticky, the T&C text sticks halfway out
          // of the nav. For this reason, we need to display the
          // form using an overlay similar to the GDPR overlay.
          if ($('nav').hasClass('nav-sticky') && $form.hasClass('emailonly-nav-signup')) {
            openFormInOverlay.call(this, '');
            $form.find('.error-wrapper').addClass('error-left').removeClass('error-top');
            let termsTextHeight = $form.find('.terms-subtext').outerHeight();
            $('.modal-back-button').css('top', `${48 + termsTextHeight}px`);
          } else if ($form.hasClass('emailonly-nav-signup')) {
            $form.find('.error-wrapper').addClass('error-top').removeClass('error-left');
          }

          $(this).parent().addClass('active');
          $form.find('.eu-extra-info.modal-on-click .promotional-offers input').attr('checked', true);
          $form.find('.terms-subtext').fadeIn(100);
        }
      );

      // Handle hiding of terms sub-text on blur of the
      // email-only sign-up form
      $('.email-only-signup input').on('blur', function () {
        let $this = $(this);
        if ($this.val() === '') {
          $this.parent().removeClass('active');
          $this.parents('.email-only-signup').find('.terms-subtext').fadeOut(100);
        }
      });
    }

    // Handle modal overlay closure
    // Note - This is not GDPR/location specific
    $('.eu-extra-info.modal-on-click .modal-back-button, #modal-backdrop').on('click', hideModal);
    $(document).on('keydown', function (e) {
      if ((e.keyCode === 27 || e.which === 27) && window.emailOnlyFormModalOpen) {
        hideModal(e);
      }
    });
  });
};

export { emailOnlySignup };
